import { useEffect, useMemo, useState } from "react";
import { Button, CheckboxMultiSelect, Modal } from "@/components";
import { useGroupStore } from "@/store/groupStore";
import { useCompanyStore } from "@/store/companyStore";
import { storeGroupService } from "@/services/storeGroupService";
import { useMutation } from "@tanstack/react-query";
import { toastError, toastSuccess } from "@/utils";
import { DEFAULT_ERROR_MESSAGE, DEFAULT_SUCCESS_MESSAGE } from "@/types";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleClose: () => void;
  userName: string;
  userId: number;
  defaultGroup: number[];
}

export const UpdateManagerGroups = ({
  open,
  setOpen,
  handleClose,
  userId,
  userName,
  defaultGroup,
}: Props) => {
  const [selectedGroup, setSelectedGroup] = useState<any[]>(defaultGroup);
  const [loadingGroupsInCompany] = useState(false);
  const { groupsInCompany } = useGroupStore();
  const { users, setUsers } = useCompanyStore();

  const updateCompanyUsersList = () => {
    const newUsers = users?.data?.map((user) => {
      if (user.id === userId) {
        return {
          ...user,
          group_ids: selectedGroup,
        };
      }
      return user;
    });
    // Update the users in the store of company
    setUsers({ ...users, data: newUsers || [], status: 200 });
  };

  const mutateMoveStoreGroup = useMutation({
    mutationFn: (data: { userId: number; groupId: number[] }) => {
      return storeGroupService.moveStoreGroup(data);
    },
    onSuccess: (resp) => {
      toastSuccess(resp?.message || DEFAULT_SUCCESS_MESSAGE);
      updateCompanyUsersList();
      handleClose();
    },
    onError: (err: any) => {
      toastError(err?.message || DEFAULT_ERROR_MESSAGE);
    },
  });

  useEffect(() => {
    setSelectedGroup(defaultGroup);
  }, [defaultGroup]);

  const storeMap = useMemo(() => {
    return new Map(groupsInCompany?.data.map((store) => [store.value, store]));
  }, [groupsInCompany?.data]);

  const selectedGroupOptions =
    selectedGroup && selectedGroup?.length > 0
      ? selectedGroup
          .map((storeValue) => storeMap.get(storeValue))
          .filter(Boolean)
      : [];

  return (
    <Modal
      open={open}
      onOpenChange={setOpen}
      title={`「${userName}」を移動`}
      overflowScroll={false}
    >
      <CheckboxMultiSelect
        label="グループ"
        placeholder="グループ一覧"
        isSearchable={true}
        isClearable={true}
        isLoading={loadingGroupsInCompany}
        options={groupsInCompany.data}
        value={selectedGroupOptions as any}
        onChange={(data) => {
          const values = data ? data.map((item) => item.value) : [];
          setSelectedGroup(values);
        }}
      />

      <div className="flex justify-end gap-4 mt-4">
        <Button
          buttonType="text"
          className="!h-12"
          type="button"
          onClick={() => {
            setSelectedGroup([]);
            handleClose();
          }}
          disabled={loadingGroupsInCompany}
        >
          キャンセル
        </Button>

        <Button
          buttonType="primary"
          className="!h-12"
          type="submit"
          isLoading={loadingGroupsInCompany}
          onClick={() => {
            mutateMoveStoreGroup.mutate({ userId, groupId: selectedGroup });
          }}
        >
          移動
        </Button>
      </div>
    </Modal>
  );
};
